export interface Settings {
  [key: string]: SettingValue;
}

export interface SettingValue {
  enabled: boolean;
  bucket?: number;
  values?: Record<string, string | number | string[]>;
}

export const DEFAULT_SETTING: SettingValue = { enabled: false };
